module.exports = __webpack_public_path__ + "img/image_webinars05@2x.a335a3c2.png";